import { useEffect } from 'react';
import { useLdFlags } from '@profile-ui-mono/utilities/hooks';
import { FLAG_NAMES, UH_EVENTS, ROUTES } from '@profile-ui-mono/utilities/constants';
import { useNavigate } from 'react-router-dom';

const preventDefault = (e) => e.preventDefault();
const uhTopNavSelector = 'a.uh-pn-button';
const uhSideNavSelector = 'a.uh-pn-title-clickable';
const uhContainerId = 'uh-container-userprofile';

const useUhNavEvents = () => {
  const flags = useLdFlags();
  const sideNavDisabled = flags[FLAG_NAMES.SIDE_NAV_DISABLED];
  const navigate = useNavigate();

  const handlePersonalInfoClick = () => navigate(ROUTES.PERSONAL_INFO);
  const handleSecurityClick = () => navigate(ROUTES.SECURITY);
  const handleSettingsClick = () => navigate(ROUTES.SETTINGS);

  useEffect(() => {
    if (!sideNavDisabled) return;

    // Listen to UH events to handle navigation
    const { addEventListener, removeEventListener } = window;
    addEventListener(UH_EVENTS.PERSONAL_INFO, handlePersonalInfoClick);
    addEventListener(UH_EVENTS.SECURITY, handleSecurityClick);
    addEventListener(UH_EVENTS.SETTINGS, handleSettingsClick);

    // Listen to UH anchor (with hrefs) clicks to prevent browser navigation
    const observer = new MutationObserver(() => {
      const uhAnchors = document.querySelectorAll(uhTopNavSelector + ', ' + uhSideNavSelector);
      uhAnchors.forEach((a) => {
        a.removeEventListener('click', preventDefault);
        a.addEventListener('click', preventDefault, true);
      });
    });
  
    const uhContainer = document.getElementById(uhContainerId);
    if (uhContainer) {
      observer.observe(uhContainer, { childList: true, subtree: true });
    }

    return () => {
      removeEventListener(UH_EVENTS.PERSONAL_INFO, handlePersonalInfoClick);
      removeEventListener(UH_EVENTS.SECURITY, handleSecurityClick);
      removeEventListener(UH_EVENTS.SETTINGS, handleSettingsClick);
      observer.disconnect();
    };
  }, [sideNavDisabled, navigate]);
};

export default useUhNavEvents;
